import React, {lazy, Suspense} from "react";

import Header from '../../header';
import 'react-animated-slider/build/horizontal.css';
import '../../css/slider-animations.css';
import '../../css/styles.css';

//Footer
import Footer from '../../footer';

// Articles
import MainArticleData from '../../components/data/MainArticleData';

// Components
import Sliders from './-components/Sliders';
import TryTraining from './-components/TryTraining';
import FamilyMemberNavigation from './-components/FamilyMemberNavigation';
import NavigationImages from './-components/NavigationImages';
import AboutUs from './-components/AboutUs';

//import { ReactQueryDevtools } from '@tanstack/react-query-devtools

const maximumSlidersCount = 1; // single slide without sliding
const articleData = new MainArticleData();
const articles = articleData.getArticleDetails();
const familyMemberNavigations = articleData.getFamilyMemberNavigations();
const bottomImageNavigation = articleData.getBottomImageNavigations();
const tryTrainingImage = articleData.getTryTrainingImage();
const aboutUsImage = articleData.getAboutUsImage();

// Optimise lazy loading of pop ups
const TopPopUp = lazy(() => import('./-components/popup/simplePopup'));
const BottomPopUp = lazy(() => import('./-components/popup/simplePopupFixedSize'));

export default function Home() {

    return  (
       <div className="page">
				 	<Header />

          <Suspense
            fallback={<div>Loading...</div>}>
            <BottomPopUp/>
          </Suspense>

          <Suspense
            fallback={<div>Loading...</div>}>
            <TopPopUp/>
          </Suspense>


          <Sliders articles={articles} maximumSlidersCount={maximumSlidersCount} />

          <FamilyMemberNavigation familyMemberNavigations={familyMemberNavigations} />

          <TryTraining tryTrainingImage={tryTrainingImage} />

          <AboutUs aboutUsImage={aboutUsImage}/>

          <NavigationImages bottomImageNavigation={bottomImageNavigation} />

		      <Footer />
	      </div>
    );
}
